import { Box } from '@mui/material';
import React from 'react';

type StudyReportSectionNumberBadgeSize = 'compact' | 'default';

interface Props {
  value: React.ReactNode;
  size?: StudyReportSectionNumberBadgeSize;
  dataTestId?: string;
}

const badgeMetricsBySize: Record<
  StudyReportSectionNumberBadgeSize,
  { minWidth: number; height: number; radius: number; fontSize: number; widePaddingX: number }
> = {
  compact: {
    minWidth: 22,
    height: 22,
    radius: 11,
    fontSize: 12,
    widePaddingX: 0.75,
  },
  default: {
    minWidth: 28,
    height: 28,
    radius: 14,
    fontSize: 13,
    widePaddingX: 1,
  },
};

const StudyReportSectionNumberBadge: React.FC<Props> = ({ value, size = 'default', dataTestId }) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const badgeMetrics = badgeMetricsBySize[size];
  const valueText = String(value);

  return (
    <Box
      data-testid={dataTestId}
      sx={(theme) => ({
        minWidth: badgeMetrics.minWidth,
        height: badgeMetrics.height,
        px: valueText.length > 2 ? badgeMetrics.widePaddingX : 0,
        borderRadius: badgeMetrics.radius,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        fontSize: badgeMetrics.fontSize,
        fontWeight: 700,
        flexShrink: 0,
      })}
    >
      {value}
    </Box>
  );
};

export default StudyReportSectionNumberBadge;
